import React from 'react';
import HoverBalloon from 'src/common/hover-balloon';
import { getText } from 'src/utils/i18n';
import { isNode } from 'src/utils/micro-utils';

const LeadtimeWithBalloon = ({ i18n }) => {
  const triggerTpl = getText(
    i18n,
    'detailModule.supplyAbility.tip',
    'If you finish the payment today, your order will ship out within the delivery date.',
  );

  if (isNode()) return <div>{triggerTpl}</div>;

  return (
    <HoverBalloon
      align="tl"
      trigger={
        <i className="next-icon next-icon-help next-icon-xs js-leadtimes-tips" />
      }
    >
      {triggerTpl}
    </HoverBalloon>
  );
};

export default LeadtimeWithBalloon;
